import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import toastr from 'toastr';

export default {
  publicLinkReportController: [
    'runtimeConstant',
    '$scope',
    'revisionService',
    'dashboardService',
    'publicLinkService',
    '$filter',
    'EXT_ICONS',
    '$rootScope',
    '$sce',
    function (
      runtimeConstant,
      $scope,
      revisionService,
      dashboardService,
      publicLinkService,
      $filter,
      EXT_ICONS,
      $rootScope,
      $sce
    ) {
      'use strict';

      function sortOperation(a, b, column) {
        var res = 0;

        switch (column.type) {
          case 'text':
            res = sortText(a, b, column);
            break;
          case 'number':
            res = sortNumber(a, b, column);
            break;
          case 'date':
            res = sortDate(a, b, column);
            break;
        }
        if (column.sorted === 'desc') return res * -1;

        return res;
      }

      function sortText(a, b, column) {
        if (column.sortExpression !== undefined) {
          var sort1 = $filter('reflect')(a, column.sortExpression);
          var sort2 = $filter('reflect')(b, column.sortExpression);

          if (sort1 === undefined) sort1 = '';
          if (sort2 === undefined) sort2 = '';
          return sort1.toString().localeCompare(sort2);
        } else {
          var value1 = $filter('reflect')(a, column.expression);
          var value2 = $filter('reflect')(b, column.expression);

          if (value1 === undefined) value1 = '';
          if (value2 === undefined) value2 = '';
          return value1.toString().localeCompare(value2);
        }
      }

      function sortNumber(a, b, column) {
        return column.sortExpression !== undefined
          ? $filter('reflect')(a, column.sortExpression) -
              $filter('reflect')(b, column.sortExpression)
          : $filter('reflect')(a, column.expression) -
              $filter('reflect')(b, column.expression);
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        if (column.sortExpression !== undefined) {
          firstDate = $filter('reflect')(a, column.sortExpression);
          secDate = $filter('reflect')(b, column.sortExpression);
        } else {
          firstDate = $filter('reflect')(a, column.expression);
          secDate = $filter('reflect')(b, column.expression);
        }
        var firstSplit = firstDate.split('/');
        var secSplit = secDate.split('/');
        firstDate = Date.parse(
          firstSplit[2] + '-' + firstSplit[1] + '-' + firstSplit[0]
        );
        secDate = Date.parse(
          secSplit[2] + '-' + secSplit[1] + '-' + secSplit[0]
        );
        if (firstDate > secDate) return 1;
        if (firstDate < secDate) return -1;
      }

      function selectedDocumentTypes(value) {
        if (arguments.length === 0) return $scope.selectedDocumentType;
        $scope.selectedDocumentType = value;
      }

      function search() {
        $scope.publicLink = [];
        revisionService
          .getPublicLinkActive($scope.selectedDocumentType)
          .then(function (data) {
            data.forEach(function (document) {
              document.linkActive = $scope.getLink(document);
              document.Code = document.Code;
              document.Title = $scope.formatedTitle(document.Title);
              document.PublicLinkUser.Name = document.PublicLinkUser.Name;

              document.PublicLinkUser.PublicLinkDate = $scope.LinkActiveDate(
                document.PublicLinkDate
              );

              $scope.publicLink.push(document);
            });
            if ($scope.publicLink.length > 0) {
              $scope.showNotification(
                'success',
                'Sua pesquisa retornou: ' + $scope.publicLink.length + ' itens.'
              );
            } else {
              $scope.showNotification('warning', 'Pesquisa sem resultado.');
            }
          });
      }

      function LinkActiveDate(date) {
        if (date === undefined) {
          return 'Ilimitado';
        } else {
          let arrayDate = date.substr(0, 10).split('-');
          return `${arrayDate[2]}/${arrayDate[1]}/${arrayDate[0]}`;
        }
      }

      function getLinkActive(data) {
        if (data.RowGuid === undefined) {
          publicLinkService.getPublicLink(data.Id).then(
            function () {
              data.linkActive = window.location.origin + '/#/public/view/' + data.RowGuid;
              $scope.loading = false;
            },
            function (err) {
              // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
              $scope.showNotification('error', err.error_description);
              $scope.close();
            }
          );
        } else {
          data.linkActive = window.location.origin + '/#/public/view/' + data.RowGuid;
          $scope.loading = false;
        }
      }

      function view(doc) {
        var url = window.location.origin + '/#/public/view/' + doc.RowGuid;
        window.open(url, '_blank');
      }

      function getLink(document) {
        var guid = document.RowGuid;
        var link = window.location.origin + '/#/public/view/' + guid;
        return link;
      }

      function copyLinkActive(value) {
        publicLinkService.getLinkShort(value).then(
          function (data) {
            var tempInput = document.createElement('input');
            tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
            tempInput.value = value;
            tempInput.value = data;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            $scope.showNotification('info', 'PUBLIC LINK COPIED');
            document.body.removeChild(tempInput);
          },
          function (err) {
            // eslint-disable-next-line no-console
            console.error('error: ', err);
          }
        );
      }

      function cancelLinkActive(revisionId, revisionTitle, linkOrigin) {
        swal
          .fire({
            title: $filter('translate')('CANCEL'),
            text: `Deseja realmente cancelar o link \'${revisionTitle}\' ?`,
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showCancelButton: true,
          })
          .then(function () {
            publicLinkService.cancelPublicLink(revisionId, linkOrigin, null).then(function () {
              $scope.isShowStatus = false;
              $scope.isSuccess = true;
              swal.fire(
                'Cancelado!',
                `O link público \'${revisionTitle}\' foi cancelado.`,
                'success'
              );

              $scope.publicLink = [];
              revisionService
                .getPublicLinkActive($scope.selectedDocumentType)
                .then(function (data) {
                  data.forEach(function (document) {
                    document.linkActive = $scope.getLink(document);
                    document.Code = document.Code;
                    document.Title = $scope.formatedTitle(document.Title);
                    document.PublicLinkUser.Name = document.PublicLinkUser.Name;

                    $scope.publicLink.push(document);
                  });
                });
            });
          });
      }

      function showNotification(level, msg) {
        toastr.options = {
          closeButton: true,
          debug: false,
          progressBar: false,
          preventDuplicates: false,
          positionClass: 'toast-top-center',
          showDuration: '1000',
          hideDuration: '1000',
          timeOut: '7000',
          extendedTimeOut: '1000',
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut',
        };

        toastr[level]($filter('translate')(msg));
      }

      function close() {
        ModalInstance.dismiss('cancel');
      }

      function saveAsPdf() {
        var filter = {};
        filter.reportType = 9;
        filter.IdDocumentType = true;
        filter.IsEmpty = true;

        if ($scope.selectedDocumentType.Id !== -1) {
          filter.FilterType =
            $filter('translate')($scope.selectedDocumentType.Name) + '.';
          filter.IdDocumentType = $scope.selectedDocumentType.Id;
          filter.IsEmpty = false;
        } else {
          filter.FilterType = $filter('translate')('ALL') + '.';
        }

        if ($scope.selectedDocumentType !== null) {
          filter.IdDocumentType = $scope.selectedDocumentType.Id;
        }
        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });

        $scope.filter = filter;
        dashboardService
          .generatePublicLinkReport(filter)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function formatedDate(date) {
        if (date === undefined) return '-';
        if (!date.contains('T')) return date;
        var result = new Date(Date.parse(date));
        return result.format('dd/mm/yyyy');
      }

      function sortColumn(column) {
        if (column.sortable !== true) return;

        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';

        var sort = function (a, b) {
          return sortOperation(a, b, column);
        };
        $scope.publicLink = $scope.publicLink.sort(sort);

        var unsorted = $scope.columns.filter(function (c) {
          return c.id !== column.id;
        });

        unsorted.forEach(function (c) {
          c.sorted = undefined;
        });
      }

      function getIcon(extension) {
        var ext = extension;

        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/default.png" ></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          var pngAdjust = ext === 'png' ? 'style="padding-bottom:1px"' : '';
          image =
            '<img src="/assets/images/file_extensions/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/default.png\';" width="18px" ' +
            pngAdjust +
            ' ></img>';
        }

        if (this.isSigned) {
          image +=
            '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        if (this.hasLinkedDocuments === true) {
          image +=
            '<img class="linked_doc" src="/assets/images/document_status/linked.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function formatedDocumentType(name) {
        return $filter('truncate')(name, 30, '...', true);
      }

      function formatedTitle(title) {
        return $scope.truncateText(title, 75);
      }

      function truncateText(string, targetCharacterLength) {
        //preciso calcular o tamanho que as tags bold estao ocupando para ficar tudo com tamanho padrao
        targetCharacterLength +=
          (string.substr(0, 60).split('<b>').length - 1) * 3;
        targetCharacterLength +=
          (string.substr(0, 60).split('</b>').length - 1) * 3;

        var length = string.length;
        if (length < targetCharacterLength) {
          return string;
        } else {
          var shortenedString = string.slice(0, targetCharacterLength);
          var tempshortenedString = shortenedString.slice(
            0,
            shortenedString.lastIndexOf(' ')
          );

          var lastMarkupBegin = -1;
          var lastMarkupEnds = -1;
          try {
            lastMarkupBegin = tempshortenedString.lastIndexOf('<b>');
            lastMarkupEnds = tempshortenedString.lastIndexOf('<');
          } catch {}
          if (lastMarkupBegin !== -1) {
            // has an opening anchor tag
            if (lastMarkupEnds === -1) {
              // not having an closing tag
              tempshortenedString = tempshortenedString.slice(
                0,
                lastMarkupBegin
              );
              return tempshortenedString + '... ';
            }
          }

          var idx = shortenedString.lastIndexOf('<');
          var endTag = shortenedString.length - 4;
          if (idx >= endTag) {
            //aqui removemos o final da string caso ela tenha a abertura de alguma tag html
            shortenedString = shortenedString.substr(0, idx);
          }
          //se foi diminuido o tamanho da string comparado a original, então vou colocar tres pontos indicando que o titulo tem mais conteudo
          return shortenedString.length >= length - 4
            ? shortenedString
            : shortenedString + '... ';
        }
      }

      function load() {
        dashboardService.getDocumentTypes().then((data) => {
          $scope.documentTypes = data;
          $scope.documentTypes.push($scope.selectedDocumentType);
          $scope.documentTypes.reverse();
        });
      }

      function run() {
        try {
          $scope.publicLink = [];
          $scope.columns = [];
          $scope.documentTypes = [];
          $scope.filter;
          $scope.selectedDocumentType = { Name: '-- TODOS --', Id: -1 };

          $scope.selectedDocumentTypes = logWrapper(
            selectedDocumentTypes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.search = logWrapper(
            search,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.LinkActiveDate = logWrapper(
            LinkActiveDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLinkActive = logWrapper(
            getLinkActive,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.view = logWrapper(
            view,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLink = logWrapper(
            getLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.copyLinkActive = logWrapper(
            copyLinkActive,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelLinkActive = logWrapper(
            cancelLinkActive,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showNotification = logWrapper(
            showNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.close = logWrapper(
            close,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveAsPdf = logWrapper(
            saveAsPdf,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDate = logWrapper(
            formatedDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumn = logWrapper(
            sortColumn,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getIcon = logWrapper(
            getIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDocumentType = logWrapper(
            formatedDocumentType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedTitle = logWrapper(
            formatedTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.truncateText = logWrapper(
            truncateText,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.load = logWrapper(
            load,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.load();
          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.imageTypes = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];
          $scope.columns = [
            {
              id: 'Code',
              width: '15%',
              header: $filter('translate')('COLUMN.CODE'),
              style: {
                'min-width': '40px',
              },
              expression: 'Code',
              sortExpression: 'Code',
              mobileShow: false,
              dataPriority: 1,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'title',
              width: '40%',
              header: $filter('translate')('COLUMN.TITLE'),
              expression: 'Title',
              style: {
                'min-width': '150px',
              },
              sortExpression: 'Title',
              tooltip: 'tooltipTitle()',
              dataPriority: 2,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'PublicLinkUser.Name',
              width: '15%',
              header: 'Usuário',
              expression: 'PublicLinkUser.Name',
              style: {
                'min-width': '20px',
              },
              sortExpression: 'PublicLinkUser.Name',
              mobileShow: false,
              visible: true,
              dataPriority: 5,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'PublicLinkUser.PublicLinkDate',
              width: '20%',
              header: 'Validade',
              expression: 'PublicLinkUser.PublicLinkDate',
              style: {
                'min-width': '20px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 5,
              disabled: false,
              sortable: true,
              type: 'text',
            },
          ];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
